import DOMAINS from '../../config/domains';
export default DOMAINS;
